import React from "react";
import { Box, Typography } from "@mui/material";

export const REFUND_INFO_HEADER_BLUE = "rgba(22, 67, 135, 1)";

export type RefundAmountInfoRow = {
  label: string;
  value: string;
};

type RefundAmountInformationBoxProps = {
  rows: RefundAmountInfoRow[];
  title?: string;
};

/** Amount summary block — matches Edit Refund proceed dialog. */
const RefundAmountInformationBox: React.FC<RefundAmountInformationBoxProps> = ({
  rows,
  title = "Information",
}) => (
  <Box
    sx={{
      p: 2,
      borderRadius: 1,
      backgroundColor: "rgba(22, 67, 135, 0.06)",
      border: "1px solid rgba(22, 67, 135, 0.12)",
    }}
  >
    <Typography
      variant="subtitle2"
      sx={{
        fontWeight: 600,
        mb: 1.5,
        color: REFUND_INFO_HEADER_BLUE,
      }}
    >
      {title}
    </Typography>
    {rows.map((row) => (
      <Box
        key={row.label}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          gap: 2,
          py: 0.75,
          "&:not(:last-child)": {
            borderBottom: "1px solid rgba(22, 67, 135, 0.08)",
          },
        }}
      >
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {row.label}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, color: "text.primary" }}
        >
          {row.value}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default RefundAmountInformationBox;
